import React, { useState } from 'react';
import Badge from '../ui/Badge';

export default function UnscheduledJobsPicker({ jobs = [], selectedJobId, onSelect, error }) {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter jobs by search term
  const filteredJobs = jobs.filter(job => {
    const search = searchTerm.toLowerCase();
    return (
      job.contractNumber?.toLowerCase().includes(search) ||
      job.customerName?.toLowerCase().includes(search) ||
      job.name?.toLowerCase().includes(search)
    );
  });

  return (
    <div>
      <label style={{
        display: 'block',
        fontSize: '13px',
        fontWeight: '600',
        color: '#2b2b2b',
        marginBottom: '6px'
      }}>
        Select Job to Schedule *
      </label>

      {/* Search Box */}
      <input
        type="text"
        placeholder="Search by contract #, customer, or location..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          width: '100%',
          padding: '10px 12px',
          border: '1px solid #ddd',
          borderRadius: '8px',
          fontSize: '14px',
          outline: 'none',
          marginBottom: '12px'
        }}
        onFocus={(e) => e.target.style.borderColor = '#8B4513'}
        onBlur={(e) => e.target.style.borderColor = '#ddd'}
      />

      {/* Jobs List */}
      <div style={{
        maxHeight: '300px',
        overflowY: 'auto',
        border: error ? '1px solid #dc2626' : '1px solid #ddd',
        borderRadius: '8px',
        background: 'white'
      }}>
        {filteredJobs.length === 0 ? (
          <div style={{
            padding: '24px',
            textAlign: 'center',
            color: '#999',
            fontSize: '13px'
          }}>
            {searchTerm ? 'No jobs match your search' : 'No unscheduled jobs available'}
          </div>
        ) : (
          filteredJobs.map((job, index) => (
            <div
              key={job.id}
              onClick={() => onSelect(job)}
              style={{
                padding: '12px 16px',
                borderBottom: index < filteredJobs.length - 1 ? '1px solid #f0f0f0' : 'none',
                cursor: 'pointer',
                background: selectedJobId === job.id ? 'rgba(139, 69, 19, 0.08)' : 'white',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => {
                if (selectedJobId !== job.id) {
                  e.currentTarget.style.background = 'rgba(0, 0, 0, 0.02)';
                }
              }}
              onMouseLeave={(e) => {
                if (selectedJobId !== job.id) {
                  e.currentTarget.style.background = 'white';
                }
              }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '6px'
              }}>
                {/* Selection Indicator */}
                <div style={{
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  border: selectedJobId === job.id ? '6px solid #8B4513' : '2px solid #ddd',
                  transition: 'all 0.2s'
                }} />

                {/* Contract Number */}
                {job.contractNumber && (
                  <span style={{
                    fontSize: '12px',
                    fontWeight: '700',
                    color: '#8B4513'
                  }}>
                    #{job.contractNumber}
                  </span>
                )}

                {/* Customer Name */}
                <span style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#2b2b2b'
                }}>
                  {job.customerName || 'Unnamed Customer'}
                </span>

                {/* Status Badge */}
                <Badge status={job.status || 'sold'}>
                  {(job.status || 'sold').replace(/_/g, ' ')}
                </Badge>
              </div>

              {/* Location */}
              {job.name && (
                <div style={{
                  fontSize: '13px',
                  color: '#666',
                  marginBottom: '4px',
                  paddingLeft: '28px'
                }}>
                  📍 {job.name}
                </div>
              )}

              {/* Job Details */}
              <div style={{
                display: 'flex',
                gap: '12px',
                fontSize: '12px',
                color: '#999',
                paddingLeft: '28px'
              }}>
                {job.windowCount > 0 && (
                  <span>{job.windowCount} window{job.windowCount !== 1 ? 's' : ''}</span>
                )}
                {job.doorCount > 0 && (
                  <span>{job.doorCount} door{job.doorCount !== 1 ? 's' : ''}</span>
                )}
                {job.durationDays && (
                  <span>{job.durationDays} day{job.durationDays !== 1 ? 's' : ''}</span>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {error && (
        <div style={{
          fontSize: '12px',
          color: '#dc2626',
          marginTop: '4px'
        }}>
          {error}
        </div>
      )}

      <div style={{
        fontSize: '11px',
        color: '#999',
        marginTop: '4px'
      }}>
        Showing {filteredJobs.length} of {jobs.length} unscheduled jobs
      </div>
    </div>
  );
}